import React from "react";
import {
  IconButton,
  RelativePopupWrapper,
  Menu,
  PopupPosition,
} from "@pushpress/shared-components";
import { useToggle } from "../../../hooks/state";

const IconsMenu = ({
  label,
  icon: Icon,
  menuItems,
}: {
  label?: string;
  menuItems: {
    label: string;
    href?: string;
    onClick?: VoidFunction;
  }[];
  icon: (icon: unknown) => JSX.Element;
}) => {
  const [showMenu, showMenuActions] = useToggle(false);

  return (
    <RelativePopupWrapper
      yOffset={10}
      popupComponent={
        <Menu>
          {menuItems.map(
            (menu) =>
              (menu.href !== undefined || menu.onClick !== undefined) && (
                <Menu.Item
                  key={menu.label}
                  label={menu.label}
                  action={() => {
                    menu.onClick === undefined
                      ? (window.location.href = menu.href)
                      : menu.onClick();
                  }}
                />
              ),
          )}
        </Menu>
      }
      popupVisible={showMenu}
      popupPosition={PopupPosition.Bottom_Center}
      setPopupVisibility={showMenuActions.set}
      dismissOnOutsideClick
    >
      <IconButton
        icon={Icon}
        onClick={showMenuActions.toggle}
        size={24}
        tooltip={label}
      />
    </RelativePopupWrapper>
  );
};

export default IconsMenu;
